import { get, post } from '@utils/request';

// 获取保险公司列表
export const queryInsuranceCompanyList = () => get('subscriptions/queryInsuranceCompanyList');

// 保存公司和用户
export const saveUserCompany = data => post('subscriptions/saveUserCompany', data);

// 详情页面
export const goodsDistribution = params => get('subscriptions/queryTGoodsDistribution', params);

// toB订单列表
export const insuranceOrderList = () => get('shop/insurance/queryInsuranceOrderList');

// toB订单详情
export const queryOrderDetail = params => get('shop/order/queryOrderDetail', params);

// 查询分享卡包礼品详情
export const queryInsuranceDetails = params => get('shop/insurance/queryInsuranceDetails', params);

// 用户领取权益
export const insuranceOrder = data => post('shop/insurance/submitInsuranceOrder', data);

// 查询卡包详情
export const queryCardsDetail = params => get('shop/insurance/queryInsuranceOrderDetails', params);

// 更改礼品卡状态
export const updateReceiveStatus = params => get('shop/insurance/updateReceiveStatus', params);

// 查询公司名
export const queryUserCompany = () => get('subscriptions/queryUserCompany');


// v2.0 按新要求重写
// toB订单详情
export const getOrderQueryOrderDetail = params => get('shop/order/queryOrderDetail', params);

// v2.0 add -------------------------

// 订单列表
export const getInsuranceQueryInsuranceOrderList = () => get('shop/insurance/queryInsuranceOrderList');
// 订单详情中的领取记录
export const getInsuranceReceiveRecords = params => get('shop/insurance/receiveRecords', params);
// 添加批次
export const postInsuranceAddBatch = data => post('shop/insurance/addBatch', data);
// 获取订单可赠份数
export const getInsuranceGetSurplus = params => get('shop/insurance/getSurplus', params);
// 获取包批次订单详情
export const getInsuranceQueryInsuranceDetailsNew = params => get('shop/insurance/queryInsuranceDetailsNew', params);
// 领取
export const postInsuranceSubmitReceiveOrder = data => post('shop/insurance/submitReceiveOrder', data);
// 领取页中的领取记录
export const getInsuranceQueryInsuranceReveived = params => get('shop/insurance/queryInsuranceReveived', params);